<template>
  <div v-show="visible" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Battery</h2>
    </div>

    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3">
        <ul v-for="item in labels" :key="item.label">
          <li>
            {{ item.label }}
            <el-tooltip
              v-if="item.tooltip"
              class=""
              effect="dark"
              :content="item.tooltip"
              placement="bottom">
              <i class="el-icon-question" style="color: #acb0bf;font-size: 16px;"></i>
            </el-tooltip>
          </li>
          <li>{{ (item.value || item.value === 0) ? item.value : '-'}}</li>
        </ul>
      </div>

      <div v-show="hasData(dataFields)" class="position-relative mt-3">
        <div :id="chartDomId" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" :chartKey="chartKey" />
        <chart-rect ref="chartRect1" :chartKey="chartKey" />
      </div>

      <div v-show="hasData(dataFields2)" class="position-relative mt-3">
        <div :id="chartDomId2" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList2" :perf_second_data="perf_second_data" :chartKey="chartKey2" />
        <chart-rect ref="chartRect2" :chartKey="chartKey2" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart, arrNotEmpty, sleep} from '../common.js'
import ChartRect from '../rect.vue'

const useChart1 = {
  data() {
    return {
      seriesInfo: [
        {name: 'BatteryLevel', dataKey: 'BatteryLevel[%]'},
      ],
      chartDomId: 'batteryLevel',
      chartKey: 'batteryLevel_chart',
    }
  },

  computed: {
    dataFields() {
      return this.seriesInfo.map(item => item.dataKey)
    }
  },

  methods: {
  }
}

const useChart2 = {
  data() {
    return {
      seriesInfo2: [
        {name: 'Power', dataKey: 'Power[mW]'},
        {name: 'Fpower', dataKey: 'FPower[mW]'},
        {name: 'Voltage', dataKey: 'Voltage[mV]'},
        {name: 'Current', dataKey: 'Current[mA]'},
      ],
      chartDomId2: 'battery',
      chartKey2: 'battery_chart',
    }
  },

  computed: {
    dataFields2() {
      return this.seriesInfo2.map(item => item.dataKey)
    }
  },

  methods: {
  }
}

export default {
  mixins: [useChart1, useChart2],
  
  inject: ['injectObj', 'hasData'],

  components: {LabelList, ChartRect},

  props: {
    testInfo3: Object,
    testInfo: Object,
    testInfo0: Object,
    testInfo2: Object,
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    labels() {
      let data = this.testInfo3

      return [
        {
          label: "Avg(Power)[mW]",
          value: data?.['Avg(Power)[mW]'],
          tooltip: '平均功耗(仅在WiFi模式下支持)',
        },
        {
          label: "FPower(帧能耗)[mW]",
          value: data?.['FPower[mW]'],
        },
        {
          label: "Sum(Battery)[mWh]",
          value: data?.['Sum(Battery)[mWh]'],
        },
        {
          label: "Avg(Voltage)[mV]",
          value: data?.['Avg(Voltage)[mV]'],
        },
        {
          label: "Avg(Current)[mA]",
          value: data?.['Avg(Current)[mA]'],
        },
        {
          label: "Avg(BatteryLevel)[%]",
          value: data?.['Avg(BatteryLevel)[%]'],
        },
      ]
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    labelsHasData() {
      return arrNotEmpty(this.labels)
    },

    visible() {
      return this.labelsHasData || this.hasData(this.dataFields) || this.hasData(this.dataFields2)
    },
  },

  methods: {
    getOption(titleText, seriesInfo) {
      return {
        title: {
          text: titleText,
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: seriesInfo.map(item => {
          return {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
          }
        }),
      }
    },

    drawChart(chartDomId, chartKey, titleText, seriesInfo) {
      let chartDom = document.getElementById(chartDomId)
      if (!chartDom) return
      if (!allChart?.[chartKey]) {
        allChart[chartKey] = echarts.init(chartDom)
      }
      allChart?.[chartKey].setOption(this.getOption(titleText, seriesInfo), {notMerge: true})
    },

    async init(isMounted) {
      this.drawChart(this.chartDomId, this.chartKey, "Battery Level", this.seriesInfo)
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)

      this.drawChart(this.chartDomId2, this.chartKey2, "Battery", this.seriesInfo2)
      await this.$nextTick()
      this.$refs.chartRect2?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>